import { QIcon_chevron_right } from '@repo/icons/index'
import classNames from 'classnames'
import { ReactElement } from 'react'
import useIsMobile from '../../../../modules/hooks/common/useIsMobile'
import { COLORS } from '../../../../modules/vars'
import HighlightedTitle from '../common/HighlightedTitle'

// 합성컴포넌트
const HighSumCardTemplate = ({
  title,
  subtitle,
  bottomSection,
  disabled = false,
  onClick,
  className = '',
}: {
  title: string | ReactElement
  subtitle: string
  bottomSection: ReactElement | null
  disabled: boolean
  onClick: () => void
  className?: string
}) => {
  const isMobile = useIsMobile()
  if (isMobile) {
    return (
      <div className={styles.highlight.item.box(disabled)} onClick={onClick}>
        <div className={styles.highlight.item.title.box}>
          <div className={styles.highlight.item.title.text}>{title}</div>
          <QIcon_chevron_right width={12} height={12} color={COLORS.GRAY600} />
        </div>
        <h3 className={styles.highlight.item.subtitle}>
          <HighlightedTitle title={subtitle} color={COLORS.PURPLE50} />
        </h3>
        {bottomSection && (
          <>
            <hr className="mt-[12px]" />
            <div className={styles.highlight.item.bottom.box}>{bottomSection}</div>
          </>
        )}
      </div>
    )
  } else {
    return (
      <div
        className={classNames(
          'mb-[12px] w-full md:w-[336px] flex cursor-pointer flex-col rounded-[6px] border border-gray-100 p-[16px] px-[16px] shadow-sm ' +
            className,
          {
            'bg-gray-200': disabled,
            'bg-white pt-[16px]': !disabled,
            'justify-between': !!bottomSection,
          }
        )}
        onClick={onClick}
      >
        <div className={styles.highlight.item.title.box}>
          <div className={styles.highlight.item.title.text}>{title}</div>
          <QIcon_chevron_right width={12} height={12} color={COLORS.GRAY600} />
        </div>
        <h3 className={styles.highlight.item.subtitle}>
          <HighlightedTitle title={subtitle} color={COLORS.PURPLE50} />
        </h3>
        <>
          {!disabled && <hr className="mt-[12px]" />}
          <div className={styles.highlight.item.bottom.box}>
            {bottomSection ? bottomSection : <div className="flex-1"></div>}
          </div>
        </>
      </div>
    )
  }
}

export default HighSumCardTemplate

const styles = {
  highlight: {
    item: {
      box: (disabled) =>
        classNames(
          disabled ? `bg-gray-200` : `bg-white`,
          `mb-[16px] rounded-[6px] border border-gray-100 px-[20px] py-[16px] shadow-sm`
        ),
      title: {
        box: `mb-[4px] flex items-center justify-between`,
        text: `text-h5 flex gap-4  font-medium text-purple-500`,
        text_pc: `flex gap-4 text-[16px] font-bold text-purple-500`,
        icon: `w-[8px]`,
      },
      subtitle: `keep-all pr-[24px]`,
      bottom: {
        box: `mt-[12px] flex items-end justify-between font-bold`,
      },
    },
  },
}
